<script lang="ts">
	import * as Popover from "#lib/web-ui/ui/popover/index.js";
	import CalendarIcon from "@lucide/svelte/icons/calendar";
	import { DateFormatter, getLocalTimeZone } from "@internationalized/date";
	import type { DateValue } from "@internationalized/date";
	import { Calendar } from "#lib/web-ui/ui/calendar/index.js";
	import { buttonVariants } from "#lib/web-ui/ui/button/index.js";
	import { cn } from "#lib/web-ui/ui/utils.js";

	let { value = $bindable() }: { value?: DateValue } = $props();

	const df = new DateFormatter("en-US", {
		dateStyle: "long"
	});

	let contentRef = $state<HTMLElement | null>(null);
</script>

<Popover.Root>
	<Popover.Trigger
		class={cn(
			buttonVariants({
				variant: "outline",
				class: "w-[280px] justify-start text-left font-normal"
			}),
			!value && "text-muted-foreground"
		)}
	>
		<CalendarIcon />
		{value ? df.format(value.toDate(getLocalTimeZone())) : "Pick a date"}
	</Popover.Trigger>
	<Popover.Content bind:ref={contentRef} class="w-auto p-0">
		<Calendar type="single" bind:value />
	</Popover.Content>
</Popover.Root>
